const temporalTypes = ['dateCompare', 'dateTimeCompare', 'timeCompare'];

function validDate(value) {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  if (!match) return false;
  const [, year, month, day] = match.map(Number);
  const leap = year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
  const days = [31, leap ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  return year >= 1 && month >= 1 && month <= 12 && day >= 1 && day <= days[month - 1];
}

function validTime(value) {
  const match = /^(\d{2}):(\d{2})(?::(\d{2}))?$/.exec(value);
  return !!match && Number(match[1]) < 24 && Number(match[2]) < 60 && Number(match[3] || 0) < 60;
}

export function isValidTemporalValue(type, value) {
  if (typeof value !== 'string') return false;
  switch (type) {
    case 'dateCompare': return validDate(value);
    case 'timeCompare': return validTime(value);
    case 'dateTimeCompare': {
      const parts = value.split('T');
      return parts.length === 2 && validDate(parts[0]) && validTime(parts[1]);
    }
    default: return false;
  }
}

// Chart labels use French dates; parse them explicitly to avoid MM/DD ambiguity.
export function parseFormulaTimestamp(value) {
  if (value instanceof Date) return new Date(value.getTime());
  if (value === null || value === undefined || value === '') return new Date(NaN);
  if (typeof value === 'string') {
    const french = /^(\d{2})[-/](\d{2})[-/](\d{4})(?:[ T](\d{2}):(\d{2})(?::(\d{2}))?)?$/.exec(value);
    if (french) {
      const [, day, month, year, hour = '00', minute = '00', second = '00'] = french;
      if (!validDate(`${year}-${month}-${day}`) || !validTime(`${hour}:${minute}:${second}`)) return new Date(NaN);
      const date = new Date(0);
      date.setFullYear(Number(year), Number(month) - 1, Number(day));
      date.setHours(Number(hour), Number(minute), Number(second), 0);
      return date;
    }
  }
  return new Date(value);
}

export function getFormulaTimestamp(row, fallback, timeOffset = 0) {
  const value = row && (row['@timestamp'] !== undefined ? row['@timestamp'] : row.key);
  let date;
  if (value !== undefined && value !== null) {
    const instant = parseFormulaTimestamp(value);
    if (!Number.isFinite(instant.getTime())) return instant;
    // Graphs display the stored UTC components plus data_timeoffset. Construct
    // local civil components explicitly so the browser timezone is not added twice.
    date = new Date(0);
    date.setFullYear(instant.getUTCFullYear(), instant.getUTCMonth(), instant.getUTCDate());
    date.setHours(instant.getUTCHours(), instant.getUTCMinutes(), instant.getUTCSeconds(), instant.getUTCMilliseconds());
  } else {
    date = parseFormulaTimestamp(fallback);
  }
  const offset = Number(timeOffset);
  if (Number.isFinite(date.getTime()) && Number.isFinite(offset)) {
    date.setHours(date.getHours() + offset);
  }
  return date;
}

export function evaluateTemporalCondition(rule, timestamp) {
  if (!temporalTypes.includes(rule.type) || !isValidTemporalValue(rule.type, rule.value)) return false;
  const date = parseFormulaTimestamp(timestamp);
  if (!Number.isFinite(date.getTime())) return false;
  const pad = number => String(number).padStart(2, '0');
  const day = `${String(date.getFullYear()).padStart(4, '0')}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
  const time = `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
  let actual;
  if (rule.type === 'dateCompare') actual = day;
  else if (rule.type === 'timeCompare') actual = time.slice(0, rule.value.length);
  else actual = `${day}T${time}`.slice(0, rule.value.length);

  switch (rule.operator) {
    case '<': return actual < rule.value;
    case '=':
    case '==': return actual === rule.value;
    case '>': return actual > rule.value;
    default: return false;
  }
}
